import { render, staticRenderFns } from "./restaurantSalesApp.vue?vue&type=template&id=1df6c81b"
import script from "./restaurantSalesApp.vue?vue&type=script&lang=js"
export * from "./restaurantSalesApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports